// extracted by mini-css-extract-plugin
module.exports = {"lessonTitleCard__lesson-cover":"lessonTitleCard_lessonTitleCard__lesson-cover__wo-CC","lessonTitleCard__lesson-title":"lessonTitleCard_lessonTitleCard__lesson-title__3YG3L"};